import { useCallback, useState } from 'react'

export const useRatingFilter = () => {
  const [minRating, setMinRating] = useState<number | null>(null)
  const [maxRating, setMaxRating] = useState<number | null>(null)

  const handleRatingClick = useCallback((rating: number) => {
    if (minRating === rating && maxRating === rating) {
      setMinRating(null)
      setMaxRating(null)
    } else if (minRating === null || maxRating === null) {
      setMinRating(rating)
      setMaxRating(rating)
    } else if (rating < minRating) {
      setMinRating(rating)
    } else if (rating > maxRating) {
      setMaxRating(rating)
    } else {
      setMinRating(rating)
      setMaxRating(rating)
    }
  }, [minRating, maxRating])

  const isRatingSelected = useCallback((rating: number) => {
    if (minRating === null || maxRating === null) {
      return false
    }

    return rating >= minRating && rating <= maxRating
  }, [minRating, maxRating])

  const resetRating = useCallback(() => {
    setMinRating(null)
    setMaxRating(null)
  }, [])

  return {
    minRating,
    maxRating,
    handleRatingClick,
    isRatingSelected,
    resetRating,
  }
}
